import axios from "axios";

export const uploadtoS3 = async (
    url: any,
    file: any,
    onUploadProgress: any
  ) => {
    let config: any = {
      method: "put",
      url: url,
      onUploadProgress: onUploadProgress,
      headers: {
        "Content-Type": file.type,
      },
      data: file,
    };
    return axios(config);
  };